"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const LOADING = {
    1: "Загрузка...",
    2: "Loading...",
    5: "Yuklanmoqda...",
    6: "Жүктелуде...", // kz
};
const getLoadingText = (langId) => {
    return LOADING[langId] || LOADING[2];
};
const FullScreenContainer = styled_components_1.default.div `
    position: fixed; // Makes the container fixed position
    top: 0;
    left: 0;
    width: 100vw; // 100% of the viewport width
    height: 100vh; // 100% of the viewport height
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(109, 113, 240);
    color: white;
    font-family: 'Arial', sans-serif;
    z-index: 9999; // Ensures it is on top of other content
`;
const TextContainer = styled_components_1.default.div `
    margin-bottom: 20px;
    text-align: center;
    font-size: 32px;
    padding: 0 20px; // To ensure text does not touch the edges
    height: ${(props) => props.height ? `${props.height}%` : '30%'};
`;
const LoadingBarContainer = styled_components_1.default.div `
    width: 45%;
    height: 5%;
    background-color: #FFFFFF;
    border-radius: 40px;
    overflow: hidden;
`;
const LoadingBar = styled_components_1.default.div `
    height: 100%;
    background: #a084ff;
    width: 0%;
    border-radius: 10px;
    transition: width 2s ease-in-out;
`;
const LoadingScreen = ({ setIsLoading, defaultDelay = 300, text, langId = 1 }) => {
    const [progress, setProgress] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            setProgress(oldProgress => {
                if (oldProgress < 100) {
                    return oldProgress + 10;
                }
                clearInterval(interval);
                setIsLoading(true);
                return 100; // Ensures the bar fully loads
            });
        }, defaultDelay);
        return () => clearInterval(interval);
    }, []);
    return (react_1.default.createElement(FullScreenContainer, null,
        react_1.default.createElement(TextContainer, { height: 20 }, text || ''),
        react_1.default.createElement(TextContainer, { height: 10 }, getLoadingText(langId)),
        react_1.default.createElement(LoadingBarContainer, null,
            react_1.default.createElement(LoadingBar, { style: { width: `${progress}%` } }))));
};
exports.default = LoadingScreen;
